var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',{staticClass:"bandcamp-container"},[_c('iframe',{staticStyle:{"border":"0","width":"100%","height":"100%"},attrs:{"src":_vm.embeddedUrl,"seamless":""}},[_c('a',{attrs:{"href":_vm.hrefUrl,"target":"_blank"}},[_vm._v("\n      "+_vm._s(_vm.albumTitle)+" by "+_vm._s(_vm.$t('message.bandName'))+"\n    ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }